import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { selectIsDesktop } from 'selectors/ui';
import DateControls from 'components/DateControls/DateControls';
import { selectSchedulesStartDate } from 'selectors/general';
import { updateStartDate } from './Schedules.saga';

const mapStateToProps = state => ({
  date: selectSchedulesStartDate(state),
  isDesktop: selectIsDesktop(state),
});

const mapDispatchToProps = {
  setDate: updateStartDate,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(DateControls);
